import { render, staticRenderFns } from "./GestionTurnosSemana.vue?vue&type=template&id=e89a3720&scoped=true"
import script from "./GestionTurnosSemana.vue?vue&type=script&lang=js"
export * from "./GestionTurnosSemana.vue?vue&type=script&lang=js"
import style0 from "./GestionTurnosSemana.vue?vue&type=style&index=0&id=e89a3720&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e89a3720",
  null
  
)

export default component.exports